(function() {
  function initCategoryFilters() {
    const buttons = document.querySelectorAll('.faq-category');
    const items = document.querySelectorAll('.faq-item');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const category = btn.dataset.category;
        items.forEach(item => {
          if (category === 'all' || item.dataset.category === category) {
            item.style.display = '';
            item.classList.remove('hidden');
          } else {
            item.style.display = 'none';
            item.classList.add('hidden');
          }
        });
      });
    });
  }

  function initAccordions() {
    const faqList = document.getElementById('faq-list');
    if (!faqList) return;

    AccordionManager.init({
      containerSelector: '#faq-list',
      toggleSelector: '.faq-item__question',
      itemSelector: '.faq-item',
      activeClass: 'active',
      singleOpen: true,
      ariaSupport: false,
      onToggle: function(item, isOpen, context) {
        // Also add 'open' class for compatibility
        if (isOpen) {
          item.classList.add('open');
        } else {
          item.classList.remove('open');
        }

        // Track FAQ opened (only when opening)
        if (isOpen && typeof window.trackFAQOpened === 'function') {
          const questionText = context.toggle.querySelector('span')?.textContent || 'Unknown';
          window.trackFAQOpened(questionText, 'faq_page');
        }
      }
    });
  }

  function init() {
    initCategoryFilters();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
